import { Wrench, Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface MaintenanceProps {
  message?: string;
  endTime?: string | null;
}

export default function Maintenance({ message, endTime }: MaintenanceProps) {
  const formatEndTime = (time: string) => {
    const date = new Date(time);
    return date.toLocaleString('en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-muted/20 p-4">
      <Card className="max-w-lg w-full">
        <CardContent className="pt-8 pb-8 text-center space-y-6">
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Wrench className="h-8 w-8 text-primary animate-pulse" />
          </div>
          
          <div className="space-y-2">
            <h1 className="text-2xl font-serif font-bold">Under Maintenance</h1>
            <p className="text-muted-foreground">
              {message || 'We are working on improving the service. Please try again later.'}
            </p>
          </div>

          {endTime && (
            <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground bg-muted/50 rounded-lg py-3 px-4">
              <Clock className="h-4 w-4" />
              <span>Expected back: {formatEndTime(endTime)}</span>
            </div>
          )}

          <div className="pt-4">
            <button 
              onClick={() => window.location.reload()} 
              className="text-primary hover:text-primary/80 underline underline-offset-4 text-sm transition-colors"
            >
              Try again
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}